export function halfPizzaConfiguration(state) {
    return state.halfPizzaConfiguration;
}

export function selectCategories(state) {
    return halfPizzaConfiguration(state).categories;
}

export function selectList(state) {
    let config = halfPizzaConfiguration(state);
    let activeCategory = config.categories
        .filter((cat) => cat.active === true)
        .shift();
    let pizzas = config.pizzas.filter(
        (pizza) => pizza.category === activeCategory.id
    );
    return pizzas.sort((a, b) => a.order - b.order);
}

export function selectSelectedPizzas(state) {
    return halfPizzaConfiguration(state).selectedPizzas;
}

export function selectFormInput(state) {
    return halfPizzaConfiguration(state).formInput;
}

export function selectMode(state) {
    return halfPizzaConfiguration(state).mode;
}

export function selectTexts(state) {
    return halfPizzaConfiguration(state).texts;
}

export function selectSubmitButtonModalConfig(state) {
    return halfPizzaConfiguration(state).modalsConfig;
}

export function selectImages(state) {
    return halfPizzaConfiguration(state).images;
}
